import type { PrinterProfile, ResolvedImage, Template } from '@tsagko/label-contracts'
import { useEffect, useState } from 'react'
import { useAdapter } from '../adapters/AdapterProvider'
import { resolveImagesForTemplate } from '../adapters/demo/resolve-images'

/** Resolve + rasterize a template's images for canvas display (WYSIWYG). */
export function useResolvedImages(
  template: Template,
  profile: PrinterProfile | undefined,
): Map<string, ResolvedImage> {
  const adapter = useAdapter()
  const [map, setMap] = useState<Map<string, ResolvedImage>>(new Map())
  useEffect(() => {
    let cancelled = false
    if (!profile || !adapter) return
    void resolveImagesForTemplate(template, profile, adapter.resources).then(m => {
      if (!cancelled) setMap(m)
    })
    return () => {
      cancelled = true
    }
  }, [adapter, template, profile])
  return map
}
